export default __webpack_public_path__ + "static/media/coral-right-type-2.41bc5519.gif";